import './comp_surya_footer.css'

const Comp_Surya_Footer=(props)=>{
    return(
        
<section class="footer suryaudyogfooter pt-50px pb-50px" style={{ backgroundImage: "url('/bh01.png')",
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          minHeight: '100%'
    }}>
  <div class="container">
    <div class="row  text-md-start ">
    
      <div class="col-md-4 mb-4 addr">
        <img src="/latest-logo.png" alt="Surya Udyog Logo" class="logo-space"/>
        <h5>Surya Udyog</h5> 
        <p>
          <strong>Corporate Office :</strong>11, Ksheer Sagar Colony, Ujjain, 456001 <br/>
          <strong>Manufacturing Unit :</strong>F/G, Industrial Estate, Agar Road,<br/>
          Ujjain (M.P.) 456010, India<br/>
        </p>  
      </div>

     
      <div class="col-md-2 mb-4 text-start">
        <h5>Information</h5>
        <ul class="list-unstyled">
          <li><a href="../about_us">About Us</a></li>
          <li><a href="../products">Products</a></li>
          <li><a href="../corporate_social_responsibility">CSR</a></li>
          <li><a href="#">Blog</a></li>
          <li><a href="../contact_us">Contact Us</a></li>
        </ul>
      </div>

     
      <div class="col-md-2 mb-4 text-end qklinks">
        <h5>Quick Links</h5>
        <ul class="list-unstyled">
          <li><a href="../copper_brass_scraps">Scraps</a></li>
          <li><a href="../sheets_circles">Sheets and Circles</a></li>
          <li><a href="../ingots">Ingots</a></li>
          <li><a href="../brass_&_copper_utensils">Brass Billets</a></li>
        </ul>
      </div>

     
      <div class="col-md-4 mb-4 text-end cntctt">
        <h5>Contact</h5>
         <p>
          <i class="fa fa-phone"></i>  +91 9131000213<br/>
          <i class="fa fa-phone"></i> +91 9425916937<br/>
         <i class="fa fa-truck"></i> john@suryaudyog.com​
        <br/>
         <i class="fa fa-envelope"></i> info@suryaudyog.com
         <br/>
         <i class="fa fa-shopping-cart"></i> purchase@suryaudyog.com
        </p>
      </div>
    </div>
    <div class="footer-bottom-sampv1">
      &copy; 2025 Ash Technologies. All rights reserved.
    </div>
  </div>
</section>
    );
}
export default Comp_Surya_Footer